module.exports = __webpack_public_path__ + "img/s5_stepimg02.a3637c13.png";